import angular from "angular";
import Vue from "vue";
import "ngVue";

import dcMap from "./Map.vue";

//////// vue 2 leaflet
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

/////// leaflet fullscreen
import "leaflet-fullscreen/dist/leaflet.fullscreen.css";
import "leaflet-fullscreen/dist/Leaflet.fullscreen";

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

import MarkerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import MarkerIcon from "leaflet/dist/images/marker-icon.png";
import MarkerShadow from "leaflet/dist/images/marker-shadow.png";

Icon.Default.mergeOptions({
  iconRetinaUrl: MarkerIcon2x,
  iconUrl: MarkerIcon,
  shadowUrl: MarkerShadow,
});
/////////


export default angular.module("directives.map", []).directive("dcMap", [
  "createVueComponent",
  function (createVueComponent) {
    return createVueComponent(Vue.component("DcMap", dcMap));
  },
]);
